import { Card, styled } from "@mui/material"

export const CardLayout = styled(Card)(({ theme: { spacing, palette } }) => ({
  backgroundColor: palette.common.cloudWhite,
  paddingBlock: spacing(1.875),
  paddingInline: spacing(2.5),
}))
